import React, {useContext, useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config';
import axios from 'axios';
import { TextField, Divider } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { v4 as uuidv4 } from 'uuid';
import useNotification from '../../../hooks/useNotification';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function ManageGroupsDialog(props) {
    const [loading, setLoading] = useState(false);
    const auth = useContext(AuthContext)
    const { notificationSuccess, notificationError } = useNotification();
    const [idEntita, setIdEntita] = useState('');
    const [city, setCity] = useState('');
    const [descrizione, setDescrizione] = useState('');
    const [tagList, setTagList] = useState([]);

    const [originalDescrizione, setOriginalDescrizione] = useState('');
    const [originalTagList, setOriginalTagList] = useState([]);

    useEffect(() => {
        async function init(){
            if(props.openManageGroupsDialog==='mod'){
                setIdEntita(props.lastCellData?.idEntita.S);
                setCity(props.lastCellData?.city.S);
                setDescrizione(props.lastCellData?.descrizione.S);

                setOriginalDescrizione(props.lastCellData?.descrizione.S);
                if(props.lastCellData?.tagList?.SS.length > 0){
                    if(props.lastCellData?.tagList?.SS.length === 1 && props.lastCellData?.tagList?.SS[0] === ""){
                        setTagList([]);
                        setOriginalTagList([]);
                    }else{
                        let arrValues = [];
                        for (let index = 0; index < props.lastCellData?.tagList?.SS.length; index++) {
                            let found = props.tags.find(item => item.id === props.lastCellData?.tagList?.SS[index]);
                            if(found)arrValues.push(found);
                        }
                        setTagList(arrValues);
                        setOriginalTagList(arrValues);
                    }
                }else{
                    setTagList([]);
                    setOriginalTagList([]);
                }
            }else{
                setIdEntita('');
                setCity('');
                setDescrizione('');
                setTagList([]);
                setOriginalTagList([]);
            }
        }
        init()
    },[props.openManageGroupsDialog])

    const insGroup = async() => {
        try {
            setLoading(true);

            const data = {
                idEntita: uuidv4(),
                descrizione: descrizione,
                tagList: tagList.map(el => el.id),
                city: props.city
            }

            const axiosParams = {
                url: '/ins-group',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data
            };

            await axios(axiosParams);
            notificationSuccess('Gruppo Aggiunto');

            await props.getGroups();
            props.handleCloseManageGroupsDialog();
            
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    const modGroup = async() => {
        try {
            setLoading(true);

            let areTagListEqual = checkEqual(tagList.map(el => el.id), originalTagList.map(el => el.id)); 
            
            const data = {
                descrizione: descrizione === originalDescrizione ? '' : descrizione,
                tagList: areTagListEqual ? false : tagList.map(el => el.id),
            }
            
            const dataToPass = {
                idEntita: idEntita,
                city: city,
                areTagListEqual,
                tagList: tagList.map(el => el.id),
                originalTagList: originalTagList.map(el => el.id),
                ExpressionAttributeNames: {},
                ExpressionAttributeValues: {},
                UpdateExpression: "SET",
            };
            
            let dataKeys = Object.keys(data);
            for (let index = 0; index < dataKeys.length; index++) {
                const element = dataKeys[index];
                
                if(!data[element]){
                    delete data[element];
                }else if(element === 'tagList'){
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"SS": data[element].length === 0 ? [""] :[...data[element]]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`; 
                }else{
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"S": data[element]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`;
                }
            }

            if(!Object.keys(data).length){
                //se non ci sono chiavi non è cambiato nulla e ritorno
                return;
            }

            const axiosParams = {
                url: '/mod-group',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: dataToPass
            };

            const response = await axios(axiosParams);
            notificationSuccess('Gruppo Aggiornato');

            let newOriginalItems = response.data.responseUpdate.Attributes

            setOriginalDescrizione(newOriginalItems?.descrizione?.S || '');
            setOriginalTagList(newOriginalItems?.tagList?.SS || []);

            await props.getGroups();
            props.handleCloseManageGroupsDialog();
            
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    function checkEqual(a, b) {
        // If lengths of array are not equal means
        // array are not equal
        if (a.length !== b.length) return false;
        a.sort();
        b.sort();
        for (let i = 0; i < a.length; i++){
            if (a[i] !== b[i]){
                return false;
            }
        }
    
        // If all elements were same.
        return true;
    }

    return (
        <Dialog className="dialog-mod-group" open={props.openManageGroupsDialog} onClose={props.handleCloseManageGroupsDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{props.openManageGroupsDialog === 'ins' ? 'Inserisci gruppo' : props?.lastCellData?.descrizione?.S}</DialogTitle>
            <DialogContent>
                <div className='dialog-group-wrapper'>
                    <div className='dialog-group-wrapper-section'>
                        <div className="dialog-group-fields">
                            <TextField
                                className="dialog-descrizione required-field-bg"
                                id="dialog-descrizione"
                                label="Descrizione"
                                type="text"
                                value={descrizione}
                                onChange={(event) => {
                                    setDescrizione(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%"
                                }}
                            />
                        </div>
                    </div>
                    
                        <Divider variant="middle"/>
                    <div className="dialog-group-fields">
                        <Autocomplete
                            className="tagList-autocomplete"
                            multiple
                            options={props.tags}
                            disableCloseOnSelect
                            value={tagList}
                            limitTags={5}
                            onChange={(event, newValue) => {
                                setTagList([...newValue]);
                            }}
                            getOptionLabel={(option) => `${option.label}`}
                            style={{ minWidth: 250 }}
                            renderInput={(params) => (
                                <TextField
                                    className="tags-autocomplete-textfield"
                                    {...params}
                                    label="Tags"
                                    variant="standard"
                                />
                            )}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={() => props.openManageGroupsDialog === 'ins' ? insGroup() : modGroup()}>
                    Salva
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseManageGroupsDialog}>
                    Esci
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ManageGroupsDialog